import React from 'react';
import './Speakers from.css';
import APISIX from "../../img/SF/APISIX.png"
import AWS from "../../img/SF/AWS.png"
import BroadcomSoftware from "../../img/SF/BroadcomSoftware.png"
import GitHub from "../../img/SF/GitHub.png"
import Google from "../../img/SF/Google.png"
import Microsoft from "../../img/SF/Microsoft.png"
import Okta from "../../img/SF/Okta.png"
import redhat from "../../img/SF/redhat.png"
import Thoughtworks from "../../img/SF/Thoughtworks.png"
import Upbound from "../../img/SF/Upbound.png"
import Jetpackio from "../../img/SF/Jetpackio.png"
import crowdar from "../../img/SF/crowdar.png"
import Percona from "../../img/SF/Percona.png"
import Crowdvac from "../../img/SF/Crowdvac.png"
import jfrog from "../../img/SF/jfrog.png"

const SpeakersFrom = (props) => {
    const state = {
        Speakers_item: [
            {
                img: AWS,
            },
            {
                img: Okta,
            },
            {
                img: Google,
            },
            {
                img: APISIX,
            },
            {
                img: redhat,
            },
            {
                img: GitHub,
            },
            {
                img: jfrog,
            },
            {
                img: Thoughtworks,
            },
            {
                img: BroadcomSoftware,
            },
            {
                img: Microsoft,
            },
            {
                img: Upbound,
            },
            {
                img: Jetpackio,
            },
            {
                img: crowdar,
            },
            {
                img: Percona,
            },
            {
                img: Crowdvac,
            },
        ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item speakers_from_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Speakers logo" />
            </div>
        );
    };

    return (
        <div className="speakers_from_wrap">
            <div className="container">
                <h2>Speakers from</h2>
                <div className="speakers_from">
                    {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
                </div>
            </div>
        </div>
    );
};

export default SpeakersFrom;